module.exports = {
  BASE_API: 'https://api.hr.lixcloud.com', //线上环境
  PLAT_NAME: '.:LixCloud®HR:.',
}
